import { Contact } from "@/types/contacts";
import { TableCell, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface ContactTableRowProps {
  contact: Contact;
  onSelect: (contact: Contact) => void;
  onDelete: (contact: Contact) => void;
}

export const ContactTableRow = ({ contact, onSelect, onDelete }: ContactTableRowProps) => {
  const { data: assignedUser } = useQuery({
    queryKey: ["user", contact.assigned_to],
    queryFn: async () => {
      if (!contact.assigned_to) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("full_name")
        .eq("id", contact.assigned_to)
        .single();
      
      if (error) throw error;
      return data;
    },
    enabled: !!contact.assigned_to,
  });

  return (
    <TableRow>
      <TableCell 
        className="font-medium cursor-pointer hover:text-primary"
        onClick={() => onSelect(contact)}
      >
        {contact.name}
      </TableCell>
      <TableCell 
        className="cursor-pointer"
        onClick={() => onSelect(contact)}
      >
        {contact.company}
      </TableCell>
      <TableCell 
        className="cursor-pointer"
        onClick={() => onSelect(contact)}
      >
        {contact.email}
      </TableCell>
      <TableCell 
        className="cursor-pointer"
        onClick={() => onSelect(contact)}
      >
        {contact.phone}
      </TableCell>
      <TableCell 
        className="cursor-pointer"
        onClick={() => onSelect(contact)}
      >
        {contact.city}, {contact.country}
      </TableCell>
      <TableCell 
        className="cursor-pointer"
        onClick={() => onSelect(contact)}
      >
        <Badge variant={
          contact.category === "active" ? "default" :
          contact.category === "prospect" ? "secondary" : "outline"
        }>
          {contact.category}
        </Badge>
      </TableCell>
      <TableCell 
        className="cursor-pointer"
        onClick={() => onSelect(contact)}
      >
        {assignedUser?.full_name || "Unassigned"}
      </TableCell>
      <TableCell>
        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(contact);
          }}
          className="text-destructive hover:text-destructive"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </TableCell>
    </TableRow>
  );
};